import CMSSectionType from 'shared/enums/CMSSectionType'
import { colors, media } from 'shared/lib'
import createSanitizedHtmlObject from 'shared/lib/sanitizeHtml'
import { ArticleQuestionAnswer, ArticleQuestionAnswers } from 'shared/types/ArticleQuestionAnswers'
import styled, { css } from 'styled-components'

type QuestionOrAnswerProps = {
  isLast: boolean
  section: ArticleQuestionAnswer
}

const QuestionOrAnswer = ({ isLast, section }: QuestionOrAnswerProps) => {
  return (
    <QAContainer $hasSectionBreak={section?.hasSectionBreak} $isLast={isLast}>
      <QAInitials data-qa="ArticleQuestionAnswerSectionInitials">{section?.initials}</QAInitials>
      {section?.type === CMSSectionType.QuestionSection ? (
        <QAQuestion data-qa="ArticleQuestionSection">{section?.question}</QAQuestion>
      ) : (
        <QAAnswer
          dangerouslySetInnerHTML={createSanitizedHtmlObject(section?.answer as string)}
          data-qa="ArticleAnswerSection"
        />
      )}
    </QAContainer>
  )
}

type ArticleQuestionAnswerSectionProps = {
  section: ArticleQuestionAnswers
}

export const ArticleQuestionAnswerSection = ({ section }: ArticleQuestionAnswerSectionProps) => {
  if (!section?.subsections || section?.subsections?.length === 0) {
    return null
  }

  return (
    <Container data-qa="ArticleQuestionAndAnswerSection">
      {section?.subsections?.map((subsection, i) => (
        <QuestionOrAnswer
          isLast={section?.subsections?.length === i + 1}
          key={subsection?.uuid}
          section={subsection}
        />
      ))}
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 120px;
  margin-top: 120px;
  width: 100vw;

  ${media.medium`
    margin-bottom: 240px;
    margin-top: 240px;
  `};
`
const QAAnswer = styled.div`
  color: #000;
  font-family: 'Ivar Text'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;

  a {
    color: ${colors.FC2_RED};
  }
`
const QAContainer = styled.div<{ $hasSectionBreak: boolean; $isLast: boolean }>`
  color: #000;
  display: flex;
  flex-direction: row;
  padding: 0 24px;
  width: 100vw;

  ${media.medium`
    padding: 0;
    width: 704px;
  `};

  ${({ $hasSectionBreak, $isLast }) =>
    $isLast
      ? css`
          margin-bottom: 0;
        `
      : $hasSectionBreak
      ? css`
          margin-bottom: 56px;
        `
      : css`
          margin-bottom: 16px;
        `}
`
const QAInitials = styled.div`
  color: ${colors.FC2_RED};
  font-family: 'Helvetica Neue'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  min-width: 56px;
  text-transform: uppercase;
`
const QAQuestion = styled.div`
  color: #000;
  font-family: 'Helvetica Neue'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  text-transform: uppercase;
`
